import React from 'react';

const ToolTipModal = ({ children }) => (
  <div className="moca-table-tooltip-modal">{children}</div>
);

export default ToolTipModal;
